import DarkWrapper from "./DarkWrapper";
import { useEffect, useRef, useState } from "react";
import useColors from "../../customHooks/useColors";
import useDisableBackground from "../../customHooks/useDisableBackground";
import BaseParagraph from "../../baseComponents/baseParagraph";
import BaseButton from "../../baseComponents/baseButton";

const CookieView = ({ acceptCookies }) => {
  const [colors] = useColors();

  const styles = {
    bottomElement: {
      position: "fixed",
      bottom: 0,
      left: 0,
      width: "100%",

      backgroundColor: colors.primary,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "20px"
    },
    cookieText: {
      color: colors.secondary,
    },
    cookieContinueButton: {
      border:  `1px solid white`,
      marginTop: "20px"
    }
  };

  //useDisableBackground({ env: "cookieView" });

  return (
    <DarkWrapper isTransparent={false} darknessFactor="0.5" env = "cookieView">
      <div className="fade-in"  style={styles.bottomElement}>
        <BaseParagraph style={styles.cookieText}>
          cookieDescription
        </BaseParagraph>
        <span style={{ width: "200px" }}>
          <BaseButton onClick={acceptCookies} style = {styles.cookieContinueButton} hasMarginTop={false}>continue</BaseButton>
        </span>
      </div>
    </DarkWrapper>
  );
};

export default CookieView;
